import { loadGraphQLData } from '../page';
import PDP from './components-v2';

export default {
    component: PDP,
    loadData: loadGraphQLData,
};
